import { Stack, Typography, Paper } from "@mui/material";
import { useMemo } from "react";
import ColorPicker from "@/components/ColorPicker";
import { MediaManager } from "@/components";
import { getThumbnailImage } from "@/utils/media";
import { useAppSelector } from "@/hooks";

export interface OrganizationVisualIdentitySettings {
    primaryColor: string;
    secondaryColor?: string;
    logo: string;
}

interface Props {
    value: OrganizationVisualIdentitySettings;
    onChange: (field: keyof OrganizationVisualIdentitySettings, value: string) => void;
}

const OrganizationVisualIdentity = ({
    value,
    onChange,
}: Props) => {
    const organizationId = useAppSelector(
        (store) => store.ui.activeOrganization
    );

    const logoUrl = useMemo(() => {
        if (!value.logo) return "";

        return getThumbnailImage({
            file: value.logo,
            organizationId,
        });
    }, [value.logo, organizationId]);

    const handleLogoChange = (selection: string[]) => {
        onChange("logo", selection[0] ?? "");
    };

    const handleColorChange = (
        e: React.ChangeEvent<HTMLInputElement>
    ) => {
        onChange(
            e.target.name as keyof OrganizationVisualIdentitySettings,
            e.target.value
        );
    };

    return (
        <Paper sx={{ p: 2 }}>
            <Stack spacing={2}>
                <Typography variant="h4">
                    Identidad Visual
                </Typography>

                <Stack spacing={1}>
                    <Typography variant="h4">
                        Logotipo
                    </Typography>

                    <Paper
                        sx={{
                            p: 2,
                            overflow: "hidden",
                            borderRadius: "12px",
                        }}
                    >
                        <MediaManager
                            value={logoUrl}
                            onChange={handleLogoChange}
                        />
                    </Paper>
                </Stack>

                <Stack spacing={1}>
                    <Typography variant="h4">
                        Colores de Marca
                    </Typography>

                    <Stack spacing={2}>
                        <ColorPicker
                            name="primaryColor"
                            value={value.primaryColor}
                            onChange={handleColorChange}
                            condensed
                        />

                        {value.secondaryColor ? (
                            <ColorPicker
                                name="secondaryColor"
                                value={value.secondaryColor}
                                onChange={handleColorChange}
                                condensed
                            />
                        ) : null}
                    </Stack>
                </Stack>
            </Stack>
        </Paper>
    );
};

export default OrganizationVisualIdentity;
